import {Injectable} from '@angular/core';
import {AbstractHideShow} from '../classes/abstract-hide-show';

@Injectable()
export class SpinnerService extends AbstractHideShow {

  constructor() {
    super();
  }
}
